
/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */
// 接口地址
// export const baseUrl = 'http://192.168.1.116:8080/rest'
// export const baseUrl = 'http://47.114.138.158:8882/rest/'
// export const baseUrl = 'http://127.0.0.1:8080/rest/'
// export const baseUrl = 'http://192.168.0.119:8080/rest/'
/**
 * @description npm run build:prod  生产环境打包
 * @description npm run build:test  测试环境打包
 */
//  const url = process.env.BASE_API;
//  export const baseUrl = url;
let url = '';
switch (process.env.NODE_ENV) {
  case 'dev':
    // url = 'http://192.168.1.19:8762/rest'
    url = 'http://192.168.1.227:8762/rest'
    // 
    // url="https://data.7895cloud.com/rest"

    break
  case 'production':
    // url = 'https://data1.laohugy.com/rest'
    url="https://data.7895cloud.com/rest"
    break
  case 'test':
    url = 'http://192.168.1.227:8762/rest'
    break
}

export const baseUrl = url;

// 接口错误异常
export const apiError = 'error'
// oss图片地址
export const ossUrl = 'https://etiger.oss-cn-hangzhou.aliyuncs.com/etiger/'

//平台类型 7895: 电老虎
export const platformType = '7895'

export default {
  baseUrl,
  apiError,
  ossUrl,
  platformType
}



// WEBPACK FOOTER //
// ./src/api/global.js